import DetailsModal from './src/components/DetailsModal';
import ErrorModal from './src/components/ErrorModal';
import RefillModal from './src/components/RefillModal';
import SuccessModal from './src/components/SuccessModal';
import ReleaseModal from './src/components/ReleaseModal';
import ReleaseBanner from './src/components/ReleaseBanner';
import UpgradeModal from './src/components/UpgradeModal';
import TransferModal from './src/components/TransferModal';
import NotEnoughBalanceModal from './src/components/NotEnoughBalanceModal';
import MetaModal from './src/components/MetaModal';
import VCModals from './src/components/VCModals';

export {
  DetailsModal,
  ErrorModal,
  RefillModal,
  SuccessModal,
  ReleaseModal,
  ReleaseBanner,
  UpgradeModal,
  TransferModal,
  NotEnoughBalanceModal,
  MetaModal,
  VCModals,
};
